function deleteCookie(cookieName) {
  document.cookie = cookieName + '=; expires=Thu, 31 Dec 1920 23:59:59 UTC; path=/';
}

window.klaroConfig = {
  elementID: 'xavinKlaro',

  lang: 'de',

  storageMethod: 'cookie',

  storageName: `xavin_cookie_consent`,

  cookieExpiresAfterDays: 14,

  privacyPolicy: '/datenschutz',

  cookieDomain: window.location.hostname,

  default: false,

  mustConsent: true,

  acceptAll: true,

  hideDeclineAll: false,

  groupByPurpose: true,

  translations: {
    zz: {
      privacyPolicyUrl: '/datenschutz',
    },
    de: {
      ok: 'Alle Cookies akzeptieren',
      acceptAll: 'Alle Cookies akzeptieren',
      acceptSelected: 'Auswahl speichern',
      consentModal: {
        title: 'Von uns verwendete Cookies',
        description:
          'Hier können Sie einsehen und anpassen, welche Cookies wir verwenden. Manche Widgets funktionieren ohne Cookies nicht, daher ist es ratsam die Cookies anzunehmen.',
      },
      consentNotice: {
        description:
          'Neben tollen Features helfen uns Cookies auch dabei unser Angebot stetig zu verbessern. Wir setzen Cookies für folgende Zwecke ein: {purposes}.',
        learnMore: 'Mehr erfahren ',
      },
      // firebase_analytics: {
      //   description: 'Firebase Analytics erfasst das Nutzerverhalten und visualisiert dieses mittels dem Firebase-Dashboard.'
      // },
      // google_analytics: {
      //   description: 'Sammeln von anonymen Nutzungsstatistiken. Die erfassten Daten helfen uns dabei unser Angebot zu verbessern.',
      // },
      // linkedin_analytics: {
      //   description: 'Sammeln von anonymen Nutzungsstatistiken. Die erfassten Daten helfen uns dabei unser Angebot zu verbessern.'
      // },
      googletagmanager: {
        description: 'Diese Cookies dienen zur Steuerung der erweiterten Script- und Ereignisbehandlung.'
      },
      essenziell: {
        description:
          'Diese Cookies werden zum richtigen Ausführen der Website benötigt.',
      },
      purposes: {
        analytics: 'Statistik',
        layout: 'Layout',
        functional: 'Funktional',
        essenziell: 'Essenziell',
      },
    },
  },

  services: [
    // {
    //   name : 'google_analytics',
    //   title : 'Google Analytics',
    //   purposes : ['analytics'],
    //   cookies : [
    //     'DSID', 'IDE', 'SIDCC', 'ANID', '1P_JAR', 'NID',
    //     'CONSENT', 'APISID', '__Secure-HSID', 'SEARCH_SAMESITE',
    //     '__Secure-3PAPISID', '__Secure-APISID', '__Secure-SSID',
    //     'SAPISID', 'SSID', 'HSID', '__Secure-3PSID', 'SID',
    //     '_gid', '_gat_gtag_UA_159539151_2', '_ga'
    //   ],
    //   callback : function(consent){
    //     var gaProperty = 'UA-159539151-2';
    //     var disableStr = 'ga-disable-' + gaProperty;
    //     if(consent){
    //       document.cookie = disableStr + '=; expires=Thu, 31 Dec 1920 23:59:59 UTC; path=/';
    //     } else {
    //       document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
    //       window[disableStr] = true;
    //     }
    //   },
    //   optOut: false,
    // },
    // {
    //   name : 'linkedin_analytics',
    //   title : 'Linkedin Analytics',
    //   purposes : ['analytics'],
    //   callback : function(consent){
    //     var enableStr = 'linkedin_enabled';
    //     if(consent){
    //       document.cookie = enableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
    //       window[enableStr] = true;
    //     } else {
    //       document.cookie = enableStr + '=; expires=Thu, 31 Dec 1920 23:59:59 UTC; path=/';
    //       window[enableStr] = false;
    //       linkedin_cookies = ['AnalyticsSyncHistory', 'UserMatchHistory	', 'bcookie', 'lang	', 'lidc	', 'li_sugr', 'bscookie']
    //       linkedin_cookies.forEach(deleteCookie);
    //     }
    //   },
    //   optOut: false,
    // },
    // {
    //   name : 'firebase_analytics',
    //   title : 'Firebase Analytics',
    //   purposes : ['analytics'],
    //   callback : function(consent){
    //     var enableStr = 'firebase_enabled';
    //     if(consent){
    //       document.cookie = enableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
    //       window[enableStr] = true;
    //     } else {
    //       document.cookie = enableStr + '=; expires=Thu, 31 Dec 1920 23:59:59 UTC; path=/';
    //       window[enableStr] = false;
    //     }
    //   },
    //   optOut: false,
    // },
    // {
    //   name : 'googletagmanager',
    //   title : 'Google Tag Manager',
    //   purposes : ['analytics'],
    //   callback : function(consent){
    //     var enableStr = 'googletagmanager_enabled';
    //     if(consent){
    //       document.cookie = enableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
    //       window[enableStr] = true;
    //     } else {
    //       document.cookie = enableStr + '=; expires=Thu, 31 Dec 1920 23:59:59 UTC; path=/';
    //       window[enableStr] = false;
    //       cookies = [ 'lang', 'U', 'fr', 'NID', '1P_JAR', 'lang', 'AnalyticsSyncHistory', 'UserMatchHistory', 'lidc', 'li_sugr', 'bcookie', 'bscookie']
    //       cookies.forEach(deleteCookie);
    //     }
    //   },
    //   optOut: false,
    // },
    {
      name: 'essenziell',
      title: 'Essenzielle Cookies',
      default: true,
      purposes: ['essenziell'],
      required: true,
    },
  ],
}

window.addEventListener('load', (event) => {
  Watcher = class Watcher {
    update(obj, name, data) {
      // data.type  'decline' , 'save'
      if (name == "applyConsents") {
        location.reload()
      }
    }
  }

  klaro.getManager().watch(new Watcher())
})
